export interface TagKeyword {
  regexp: RegExp;
  weight: number;
}

export interface Tag {
  name: string;
  keywords: TagKeyword[];
}

export interface NewTag {
  id: string;
  label?: string;
  synonyms?: string[];
  type: TagType;
  classifier?: TagClassifier;
  sortOrder?: number;
}

export interface TagClassifier {
  engine: TagClassifierEngine;
  keywords?: TagClassifierKeyword[];
}

export interface TagClassifierKeyword {
  regexp: RegExp;
  weights: {
    title: number;
    description: number;
  };
}

export interface AssignedTag {
  id?: string;
  name?: string;
  score: number;
}

export enum TagType {
  JOB_POST_META = "JOB_POST_META",
  JOB = "JOB",
  COMPENSATION_BENEFIT = "COMPENSATION_BENEFIT",
  ORGANISATION = "ORGANISATION",
  ROLE = "ROLE",
  EXPERIENCE_LEVEL = "EXPERIENCE_LEVEL",
  PROGRAMMING_LANGUAGE = "PROGRAMMING_LANGUAGE",
  TECHNOLOGY = "TECHNOLOGY",
  MARKET = "MARKET",
  EMPLOYMENT_TYPE = "EMPLOYMENT_TYPE",
}

export enum TagClassifierEngine {
  KEYWORD_MATCH = "KEYWORD_MATCH",
  ROLE_MATCH = "ROLE_MATCH",
  IS_4_DAY_WEEK = "IS_4_DAY_WEEK",
  IS_OUTSIDE_IR35 = "IS_OUTSIDE_IR35",
  IS_VISA_SPONSORED = "IS_VISA_SPONSORED",
  IS_RELOCATION_PAID = "IS_RELOCATION_PAID",
  IS_FULLY_REMOTE = "IS_FULLY_REMOTE",
}
